<template>
  <div>
    <div class="card-header py-3">
      {{ $t("guest_hub.display_header") }}
    </div>
    <div class="card-body mt-2">
      <table class="table table-bordered text-center">
        <thead>
          <tr>
            <th rowspan="2" class="align-middle">{{ $t("guest_hub.checkin_label") }}</th>
            <th colspan="3">{{ $t("guest_hub.display_col_screens") }}</th>
            <th>{{ $t("guest_hub.display_col_quick_checkin") }}</th>
          </tr>
          <tr>
            <th>{{ $t("virtual_kiosk.start_checkin") }}</th>
            <th>{{ $t("virtual_kiosk.start_checkin_qr") }}</th>
            <th>{{ $t("virtual_kiosk.start_pre_checkin") }}</th>
            <th>{{ $t("guest_hub.display_must_switch_on") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in matrix"
            :key="row.mode"
            :class="{ 'table-primary': row.mode === checkin_mode }"
          >
            <td class="text-left">{{ row.label }}</td>
            <td>{{ row.start ? $t("guest_hub.display_yes") : "" }}</td>
            <td>{{ row.qr ? $t("guest_hub.display_yes") : "" }}</td>
            <td>{{ row.pre ? $t("guest_hub.display_yes") : "" }}</td>
            <td>{{ row.quick ? $t("guest_hub.display_yes") : "" }}</td>
          </tr>
        </tbody>
      </table>

      <p class="text-muted">{{ $t("guest_hub.display_checkout_note") }}</p>
    </div>
  </div>
</template>

<script>
import {
  GUEST_HUB_SETTING_NAME,
  KIOSK_CHECKIN_MODES,
} from "../../checkin/kiosk/kiosk_config";

export default {
  data() {
    return {
      checkin_mode: null,
    };
  },
  computed: {
    matrix() {
      return [
        { mode: KIOSK_CHECKIN_MODES.NOT_IN_USE, label: this.$t("guest_hub.mode_not_in_use"), start: false, qr: false, pre: false, quick: false },
        { mode: KIOSK_CHECKIN_MODES.BOTH, label: this.$t("guest_hub.mode_confirm_pre_start"), start: true, qr: true, pre: false, quick: true },
        { mode: KIOSK_CHECKIN_MODES.PRE_CHECKIN_ONLY, label: this.$t("guest_hub.mode_confirm_pre_only"), start: false, qr: true, pre: false, quick: true },
        { mode: KIOSK_CHECKIN_MODES.START_CHECKIN_ONLY, label: this.$t("guest_hub.mode_start_checkin_only"), start: true, qr: false, pre: false, quick: true },
        { mode: KIOSK_CHECKIN_MODES.START_PRE_CHECKIN_ONLY, label: this.$t("guest_hub.mode_start_pre_checkin_only"), start: false, qr: false, pre: true, quick: true },
      ];
    },
  },
  async mounted() {
    const facility = window._app_facility;
    const setting = await this.$lionheart
      .get("/v2/facility-settings", {
        params: {
          name: GUEST_HUB_SETTING_NAME,
          facility_id: facility.id,
          paginate: 0,
        },
      })
      .then((r) => r.data.data);

    if (setting.length) this.checkin_mode = setting[0].value?.checkin_mode ?? null;
  },
};
</script>
